import { useParams } from "react-router-dom";
import { HeaderComponent } from "Components/Shared";
import ReviewRequestsList from "Components/Shared/ReviewRequests/List";

const CoachScopedReviewRequests = () => {
  const { id } = useParams();
  const coachId = Number(id);
  return (
    <div className="ss-page-content d-flex flex-column flex-1 scroll-y bg-white">
      <HeaderComponent title="Review Requests" shouldShowNav={true} />
      <div className="ss-page-body d-flex flex-column flex-1 scroll-y py-4 px-4">
        {coachId > 0 ? (
          <ReviewRequestsList filters={{ coach_id: coachId }} />
        ) : (
          <div className="text-muted">Invalid coach</div>
        )}
      </div>
    </div>
  );
};

export default CoachScopedReviewRequests;
